import Color from '@ecm/ui/element/Color'

type Opts = React.CSSProperties & {
  [k: string]: string | number | React.CSSProperties | undefined
}

export const inputStyle: Opts = {
  '::placeholder': { color: Color.mono.lighter },
  border: `1px solid ${Color.smoke.normal}`,
  borderRadius: '.25em',
  boxSizing: 'border-box',
  fontFamily: '"Mulish", sans-serif',
  fontSize: '1em',
  height: '3.5em',
  padding: '1em 1em 0 50px',
  width: '100%',
}

export const labelStyle: Opts = {
  color: Color.saint.normal,
  fontFamily: '"Mulish", sans-serif',
  fontSize: '0.75em',
  padding: '0',
  position: 'absolute',
  top: '0.6em',
}
